import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { List, fromJS } from 'immutable';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

// eslint-disable-next-line no-restricted-imports -- pre-existing DataTable2 usage; migrate off when touched
import DataTable from '@sophocles/components/DataTable2';
import WindowSizeHOC from '@sophocles/components/WindowSizeHOC';
import { fetchSiteHardwareHistory } from '@sophocles/entities/Site';
import { windowSizes } from '@sophocles/utils';

const formatUser = value =>
  value.get('id', 0) +
  '. ' +
  value.get('first_name', '') +
  (value.get('last_name', null) ? ' ' + value.get('last_name') : '');

const formatDeviceType = type =>
  type
    .split('_')
    .map(v => _.capitalize(v))
    .join(' ');

class HardwareHistoryDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: List(),
    };
  }

  componentDidMount() {
    const { siteId, fetchHardwareHistory } = this.props;

    const { t } = this.props;
    fetchHardwareHistory(siteId ?? 0).then(res => {
      if (_.has(res, 'error')) {
        alert(t('sites.hwHistory.fetchError', 'error pulling up history.'));
      } else {
        this.setState({
          data: res.get('result', List()).map(entry => entry.set('moment', moment(entry.get('timestamp', null)))),
        });
      }
    });
  }

  onRadioIdClick = (e, value) => {
    e.preventDefault();
    const radioDetailUrl = `/support/radios/${value.get('id')}`;
    this.props.onRadioIdClick(radioDetailUrl);
  };

  render() {
    const { closeDialog, isStaff, windowWidth, t } = this.props;

    const onMobile = windowWidth <= windowSizes.mobile.width;

    const { data } = this.state;

    const columns = fromJS([
      {
        name: t('general.timestamp', 'Timestamp'),
        id: 'moment',
        cellRenderer: value => (value ? value.format('L, LTS') : t('general.none', 'None')),
      },
      {
        name: t('sites.hwHistory.device', 'Device'),
        id: 'device_type',
        sortable: false,
        cellRenderer: value => (value ? formatDeviceType(value) : t('general.unknown', 'Unknown')),
      },
      {
        name: t('sites.hwHistory.radio', 'Radio'),
        id: 'radio',
        sortable: false,
        cellRenderer: value =>
          value == null ? (
            t('general.none', 'None')
          ) : isStaff ? (
            <a href="#" onClick={e => this.onRadioIdClick(e, value)}>
              {value.get('iccid', '')}
            </a>
          ) : (
            value.get('iccid', '')
          ),
      },
      {
        name: t('general.user', 'User'),
        id: 'user',
        sortable: false,
        cellRenderer: value => (value != null ? formatUser(value) : t('general.unknown', 'Unknown')),
      },
      {
        name: t('sites.hwHistory.action', 'Action'),
        id: 'action',
        sortable: false,
      },
    ]);

    const actions = [
      <Button key="close" variant="outlined" onClick={closeDialog}>
        {t('actions.close', 'Close')}
      </Button>,
    ];

    let previousExists = false;
    const completedData = data
      .sortBy(entry => entry.get('moment'))
      .map(entry => {
        let action = t('sites.hwHistory.install', 'Install');
        const radio = entry.get('radio', null);
        if (radio == null) {
          action = t('sites.hwHistory.remove', 'Remove');
        } else if (previousExists) {
          action = t('sites.hwHistory.change', 'Change');
        }
        previousExists = !!radio;
        return entry.set('action', action);
      });

    return (
      <Dialog open={this.props.open} onClose={closeDialog} style={{ overflowY: 'scroll' }}>
        <DialogTitle>{t('sites.hardwareHistory', 'Hardware History')}</DialogTitle>
        <DialogContent dividers>
          <DataTable
            columns={columns}
            data={completedData}
            // searchFields={['version', 'release_notes', 'active']}
            // fetchData={this.getFetchFunction()}
            defaultSortBy="moment"
            defaultSortDesc={true}
            entryCountOptions={[-1]}
            defaultEntryCount={-1}
            hidePaging={true}
            hideSearch={true}
            hideResults={true}
          />
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    // patchRelayController: (values) => dispatch(createSite(values)),
    fetchHardwareHistory: site => dispatch(fetchSiteHardwareHistory(site)),
  };
}

const HardwareHistoryDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(WindowSizeHOC(withTranslation()(HardwareHistoryDialog)));

export default HardwareHistoryDialogContainer;
